import { useGradientAnimation } from '@/hooks/useGradientAnimation'
import { cn } from '@/lib/utils'
import { motion } from 'framer-motion'

type GradientVariant = {
  background: string
  color: string
}

interface AnimatedGradientButtonProps {
  label: string
  linkTo: string
  baseColor?: GradientVariant
  gradients: GradientVariant[]
  icon?: React.ReactNode
  biKey?: string
  className?: string
}

const defaultBase: GradientVariant = {
  background: '#00A0CB',
  color: 'rgba(255,255,255,1)',
}

export function AnimatedGradientButton({
  label,
  linkTo,
  baseColor = defaultBase,
  gradients,
  icon,
  biKey,
  className,
}: AnimatedGradientButtonProps) {
  const controls = useGradientAnimation()

  const variants = {
    base: {
      background: baseColor.background,
      color: baseColor.color,
      transition: { duration: 0.3, ease: 'easeOut' },
    },
    gradient1: {
      background: gradients[0]?.background,
      color: gradients[0]?.color,
      transition: { duration: 1, ease: 'easeOut' },
    },
    gradient2: {
      background: gradients[1]?.background,
      color: gradients[1]?.color,
      transition: { duration: 1, ease: 'easeOut' },
    },
  }

  return (
    <div
      data-bi-key={biKey}
      onClick={() => (window.location.href = linkTo)}
      className={cn('size-full', className)}
    >
      <motion.div
        initial="base"
        animate={controls}
        variants={variants}
        className="relative flex w-full items-center justify-center gap-2 rounded-full px-[20px] py-[12px] text-center text-[18px] leading-[22px] font-semibold tracking-[0.2px]"
      >
        {icon}
        {label}
      </motion.div>
    </div>
  )
}
